/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import purchaseDashboardActions from "../../../../Purchase/Dashboard/redux/actions";
import { currencyFormat, idNamingConversion } from "../../../../../helpers/utilities";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import ReportModal from "../../ReportModal";
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import { emptyValidation } from "../../../../../helpers/validation";
import {
    Button,
    Box
} from "@mui/material";
import clsx from "clsx";
import { Space, Col, Row } from 'antd';


export const Top10Supplier = (props) => {
    const { visible, onTopSupplierVisible, title, onMenuTitle } = props;
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { purchaseDashboardDetails } = useSelector(state => state.purchaseDashboardReducer);
    const [topSupplier, setTopSupplier] = useState('');
    const [topSupplierValue, setTopSupplierValue] = useState('');
    const [topSupplierVTitle, setTopSupplierVTitle] = useState('');
    const [topSupplierValueTitle, setTopSupplierValueTitle] = useState('');
    const [customerData, setCustomerData] = useState([]);
    const [reportOpen, setReportOpen] = useState(false);
    const [errorTopSupplierValue, setErrorTopSupplierValue] = useState(false);
    const [errorTopSupplier, setErrorTopSupplier] = useState(false);
    const dispatch = useDispatch();

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        if (purchaseDashboardDetails !== '' && topSupplier !== '' && topSupplier !== '') {
            setCustomerData(purchaseDashboardDetails[`${topSupplierValue}_${topSupplier}`]);
            setReportOpen(true);
            onTopSupplierVisible(false);
        }
    }, [purchaseDashboardDetails])

    const topSupplierFilter = (e) => {
        e.preventDefault();
        let emptyTopSupplier = emptyValidation('Top Supplier', topSupplier, 'dropDown');
        let emptyTopSupplierValue = emptyValidation('Top Supplier', topSupplierValue, 'dropDown');
        if (emptyTopSupplier.isValid && emptyTopSupplierValue.isValid) {
            if (purchaseDashboardDetails === undefined || purchaseDashboardDetails === '') {
                dispatch({ type: purchaseDashboardActions.PURCHASE_DASHBOARD_START, url: 'purchasedashboard' });
            } else {
                setCustomerData(purchaseDashboardDetails[`${topSupplierValue}_${topSupplier}`]);
                setReportOpen(true);
                onTopSupplierVisible(false);
                setTopSupplier('');
                setTopSupplierValue('');
            }
        } else {
            if (emptyTopSupplier.errors !== '') {
                setErrorTopSupplier(emptyTopSupplier.errors);
            }
            if (emptyTopSupplierValue.errors !== '') {
                setErrorTopSupplierValue(emptyTopSupplierValue.errors);
            }
        }
    }

    const topSupplierTitle = (value) => {
        switch (value) {
            case "60": return 'Last 60 days';
            case "120": return 'Last 120 days';
            default: return 'Last 300 days';
        };
    }

    const topSupplierTitleValue = (value) => {
        switch (value) {
            case "top_suppliers_amount": return ' By Value';
            default: return ' By Transactions';
        };
    }

    const handleClose = () => {
        setTopSupplier('');
        onTopSupplierVisible(false);
        onMenuTitle('');
        setErrorTopSupplierValue(false);
        setErrorTopSupplier(false);
        setTopSupplierVTitle('');
        setTopSupplierValueTitle('');
    }

    const classes = customStyles();
    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => topSupplierFilter(e)}>
                        <div className={classes.customFormFlex}>
                            <AutoCompleteComponent
                                name={["By Value / Transactions ", <span key="By Value / Transactions" className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'label', 'name': 'By Value / Transactions' }]}
                                details={[{ "id": "top_suppliers_amount", "label": "By Value" }, { "id": "top_suppliers_invoice", "label": "By Transactions" }]}
                                parentValue={customObject([{ "id": "top_suppliers_amount", "label": "By Value" }, { "id": "top_suppliers_invoice", "label": "By Transactions" }], topSupplierValue)}
                                onChange={(data) => { setTopSupplierValue(data.id); setTopSupplierValueTitle(data.id) }}
                                position={'bottom'}
                                id={idNamingConversion('By Value / Transactions', 'top10Supplier', 'DropDown')}
                                parentError={errorTopSupplierValue}
                            />
                            <AutoCompleteComponent
                                name={["Number of Days ", <span key="Number of Days" className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'label', 'name': 'Number of Days' }]}
                                details={[{ "id": "60", "label": "Last 60 Days" }, { "id": "120", "label": "Last 120 Days" }, { "id": "300", "label": "Last 300 Days" }]}
                                parentValue={customObject([{ "id": "60", "label": "Last 60 Days" }, { "id": "120", "label": "Last 120 Days" }, { "id": "300", "label": "Last 300 Days" }], topSupplier)}
                                onChange={(data) => { setTopSupplier(data.id); setTopSupplierVTitle(data.id) }}
                                position={'bottom'}
                                id={idNamingConversion('Number of Days', 'top10Supplier', 'DropDown')}
                                parentError={errorTopSupplier}
                                customClasses={classes.margin30t}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn)}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn)}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>{title} - {topSupplierTitleValue(topSupplierValueTitle)}</h4>
                            <p className={classes.downloadsHeading}>{topSupplierTitle(topSupplierVTitle)}</p>
                        </div>
                        <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                            <Col span={8}><h6>Supplier Name</h6></Col>
                            <Col span={6}><h6>Invoices</h6></Col>
                            <Col span={5}><h6 className={classes.textAlignRight}>Balance Amount</h6></Col>
                            <Col span={5}><h6 className={classes.textAlignRight}>Invoice Amount</h6></Col>
                        </Row>
                        {
                            customerData?.length > 0 ? customerData.map((data, i) => (
                                <Row className={clsx(classes.bill, 'no-break')}>
                                    <Col span={8}><p>{data.name}</p></Col>
                                    <Col span={6}><p>{data.invoices}</p></Col>
                                    <Col span={5}><p className={classes.textAlignRight}>₹ {currencyFormat(data.balanceAmount)}</p></Col>
                                    <Col span={5}><p className={classes.textAlignRight}>₹ {currencyFormat(data.invoiceAmount)}</p></Col>
                                </Row>)) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                        }
                    </>
                }
                businessDetails={businessDetails}
                handleClose={() => { setReportOpen(false); handleClose(); }}
            />
        </>
    )
}
